import React from "react";
import { XCircle, CheckCircle2, Star, RefreshCcw } from "lucide-react";
import { getPlanPricing, hasActiveSubscription } from "./subscriptionUtils";
import { useNavigate } from "react-router-dom";

const StatCard = ({ number, label }) => (
  <div className="stat-card">
    <h2>{number ?? "—"}</h2>
    <p>{label}</p>
  </div>
);

const PriceCard = ({ title, pricing, suffix, badge }) => {
  if (!pricing) return null;

  const offer =
    pricing?.offerPrice ??
    pricing?.salePrice ??
    pricing?.amount ??
    pricing?.price;
  const original =
    pricing?.originalPrice ??
    (pricing?.offerPrice != null ? pricing?.price : null);
  const currency = "AED ";
  const showOriginal =
    original != null && offer != null && Number(original) !== Number(offer);

  return (
    <div className="price-card">
      {badge && <div className="best-badge">{badge}</div>}
      <p>{title}</p>
      <h2>
        {currency}
        {offer ?? "—"}
        {showOriginal && (
          <span>
            {currency}
            {original}
          </span>
        )}
      </h2>
      <small>{suffix}</small>
    </div>
  );
};

const RightCards = ({ subscription, isLoading, isError }) => {

  const navigate = useNavigate();
  if (isLoading) {
    return <div className="right-section">Loading plan details...</div>;
  }

  if (isError) {
    return <div className="right-section">Unable to load plan details.</div>;
  }

  

  const plan = subscription?.plan;
  const renewDisabled = hasActiveSubscription(subscription);
  const availablePlans = Array.isArray(subscription?.availablePlans)
    ? subscription.availablePlans
    : [];
  const displayPlan =
    plan ||
    availablePlans.find((item) => item?._id === subscription?.planCode) ||
    availablePlans.find((item) => item?.isPopular) ||
    availablePlans[0] ||
    null;
  const limits = displayPlan?.limits ?? plan?.limits ?? {};
  const defaultPricing = getPlanPricing(displayPlan);
  const companyPricing =
    getPlanPricing(displayPlan, "company") ?? defaultPricing;
  const individualPricing =
    getPlanPricing(displayPlan, "individual") ??
    getPlanPricing(displayPlan, "user") ??
    defaultPricing;
  const features = Array.isArray(displayPlan?.features)
    ? displayPlan.features
    : [];

  return (
    <div className="right-section">
      <div className="stats-grid">
        <StatCard number={limits.maxUsers} label="Max Users" />
        <StatCard number={limits.maxProducts} label="Max Products" />
        <StatCard
          number={limits.maxApplicationImages ?? limits.maxApplicationImages}
          label="Max Application Images"
        />
        <StatCard
          number={
            limits.storageSpaceInGB != null
              ? `${limits.storageSpaceInGB}GB`
              : null
          }
          label="Storage Space"
        />
      </div>

      <PriceCard
        title="Company Pricing"
        pricing={companyPricing}
        suffix="/ month"
        badge={displayPlan?.isPopular ? "BEST VALUE" : null}
      />

      <PriceCard
        title="Individual User"
        pricing={individualPricing}
        suffix="/ User"
      />

      <div className="feature-card">
        <h4>
          <Star size={16} />
          Included in {displayPlan?.name || plan?.name || "Plan"}
        </h4>
        <ul>
          {features.length > 0 ? (
            features.map((feature, idx) => (
              <li key={idx}>
                <CheckCircle2 size={16} />
                {feature}
              </li>
            ))
          ) : (
            <li>
              <CheckCircle2 size={16} />
              No features listed
            </li>
          )}
        </ul>
      </div>

      <button
        type="button"
        onClick={() => navigate("/plans")}
        className="renew-btn"
        disabled={renewDisabled}
        title={renewDisabled ? "Renewal is available after this subscription ends" : "Renew plan"}
      >
        <RefreshCcw size={18} />
        {renewDisabled ? "Renewal unavailable" : "Renew Plan"}
      </button>

      
      <button type="button" className="upgrade-btn" onClick={() => navigate("/plans")}>
        Upgrade Plan
      </button>
      
    </div>
  );
};

export default RightCards;
